import { RoutePath } from "@/routes/enum"
import { CustomRouteObject } from "@/types/type";
import { lazy } from "react";
import { Navigate } from "react-router";

const Management = lazy(() => import('./index'));
const AuthManagement = lazy(() => import('@/pages/auth/management'));
const Users = lazy(() => import('@/pages/user-management/list'));
const UserDetail = lazy(() => import('@/pages/user-management/detail'));
const UserGroups = lazy(() => import('@/pages/user-group-management/list'));
const UserGroupDetail = lazy(() => import('@/pages/user-group-management/detail'));
// const Roles = lazy(() => import('@/pages/role-management/list'));
const RolesGroup = lazy(() => import('@/pages/role-management/rolesManage'));
const RoleDetail = lazy(() => import('@/pages/role-management/detail'));
const ApplicationManagement = lazy(() => import('@/pages/app-management/list'));
const AppDetail = lazy(() => import('@/pages/app-management/detail'));
const Projects = lazy(() => import('@/pages/project-management/list'));
const ProjectDetail = lazy(() => import('@/pages/project-management/detail'));

const managementRoutes: CustomRouteObject[] = [
  {
    path: RoutePath.MANAGEMENT,
    name: '管理中心',
    checkAuth: false,
    element: <Management />,
    children: [
      {
        path: RoutePath.MANAGEMENT,
        name: '管理中心',
        checkAuth: false,
        hidden: true,
        element: <Navigate to={`${RoutePath.MANAGEMENT}${RoutePath.USERS}`} />
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.USERS}`,
        name: '用户',
        checkAuth: true,
        element: <Users />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.USER_DETAIL}`,
        name: '用户详情',
        hidden: true,
        checkAuth: true,
        element: <UserDetail />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.USER_GROUPS}`,
        name: '用户组',
        checkAuth: true,
        element: <UserGroups />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.USER_GROUP_DETAIL}`,
        name: '用户组详情',
        hidden: true,
        checkAuth: true,
        element: <UserGroupDetail />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.ROLES}`,
        name: '角色',
        checkAuth: true,
        element: <RolesGroup />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.ROLE_DETAIL}`,
        name: '角色详情',
        hidden: true,
        checkAuth: true,
        element: <RoleDetail />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.APP}`,
        name: '应用',
        checkAuth: true,
        element: <ApplicationManagement />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.APP_DETAIL}`,
        name: '应用详情',
        hidden: true,
        checkAuth: true,
        element: <AppDetail />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.PROJECTS}`,
        name: '项目',
        checkAuth: true,
        element: <Projects />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.PROJECT_DETAIL}`,
        name: '项目详情',
        hidden: true,
        checkAuth: true,
        element: <ProjectDetail />,
      },
      {
        path: `${RoutePath.MANAGEMENT}${RoutePath.AUTH_MANAGEMENT}`,
        name: '主系统权限',
        checkAuth: true,
        element: <AuthManagement />,
      },
    ]
  },
]

export default managementRoutes